export enum SkinCheckRecencyEnum {
  LessThanOneYear = 'LessThanOneYear',
  OneToFiveYears = 'OneToFiveYears',
  MoreThanFiveYears = 'MoreThanFiveYears',
  Never = 'Never',
  Unknown = 'Unknown',
}
